import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const LearningPageMainSection = ({
  children,
  viewProps
}) => /*#__PURE__*/_jsx(View, Object.assign({
  flexGrow: 1
}, viewProps, {
  children: children
}));
export default LearningPageMainSection;